import { json, type ActionFunctionArgs } from '@remix-run/node';
import { z } from 'zod';
import { updateConversationStatus } from '~/modules/chat/api/update-conversation-status.server';

export const UPDATE_CONVERSATION_STATUS_ACTION =
    '/actions/update-conversation-status';

const FORM_DATA_SCHEMA = z.object({
    conversationID: z.coerce.number().int().positive(),
    status: z.object({
        archived: z.boolean().optional(),
        important: z.boolean().optional(),
        markAsDone: z.boolean().optional(),
        unread: z.boolean().optional(),
    }),
});

/**
 * API endpoint to update one or more status(es) of a conversation. Use with the
 * `useConversation` hook.
 * @see {@link packages/web/app/modules/chat/hook/useConversation.ts}
 */
export const action = async ({ context, request }: ActionFunctionArgs) => {
    const { logger } = context;
    const payload = await request.json();
    const result = FORM_DATA_SCHEMA.safeParse(payload);

    if (!result.success) {
        return json(null, { status: 400 });
    }

    try {
        const response = await updateConversationStatus({
            context,
            conversationID: result.data.conversationID,
            status: result.data.status,
        });

        if (!response) {
            return json(null, { status: 500 });
        }

        return json({
            conversation: response.conversation,
            participant: response.participant ?? null,
        });
    } catch (error) {
        logger.error(`Error in ${UPDATE_CONVERSATION_STATUS_ACTION}`, {
            error,
            data: result.data,
        });
        return json(null, { status: 500 });
    }
};
